exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/meghneel/work/baba_frontend/src/app/masters/lr-freight-master/lr-freight-master.component.css
// module id = ../../../../../src/app/masters/lr-freight-master/lr-freight-master.component.css
// module chunks = main